import Indexdasboard from "../../components/dashboard/IndexDashbord";
import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  Card,
  CardContent,
  TextField,
  Checkbox,
  Button,
  Divider,
  Pagination,
  IconButton,
} from "@mui/material";
import LabelTypography from "../../components/Typography/LabelTypography";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import axios from "axios";
import { urlServeur } from "../../util/env";
import { useNavigate } from "react-router-dom";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";
import { formatDate } from "../../services/functions";
import { Api_Token } from "../../util/Api";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddCommandDialog from "../../components/popup/AddCommand";
export default function PageBookingList() {
  return <Indexdasboard Children={<BookingList />} />;
}

function BookingList() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedBookings, setSelectedBookings] = useState([]);
  const [openAddCommand, setOpenAddCommand] = useState(false);
  const navigate = useNavigate();
  const fetchJourneys = useCallback(
    async (currentPage, rowsPerPage) => {
      const fetchData = async () => {
        try {
          const response = await Api_Token.get(`command/getCommandFilter?page=${currentPage + 1
            }&perPage=${rowsPerPage}&filter=${filter} `)
          setData(response.data.data);
          setTotalCount(response.data.total);
        } catch (error) {
          console.error("Error fetching journeys:", error);
        }
      };

      // Introduce a delay of 1s (debounce effect)
      const timeout = setTimeout(fetchData, 1000);

      return () => clearTimeout(timeout);
    },
    [filter, currentPage, rowsPerPage]
  );

  useEffect(() => {
    fetchJourneys(currentPage, rowsPerPage);
  }, [fetchJourneys, currentPage, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleSelectBooking = (booking) => {
    setSelectedBookings((prevSelected) =>
      prevSelected.includes(booking)
        ? prevSelected.filter((b) => b.id !== booking.id)
        : [...prevSelected, booking]
    );
  };

  const handleNavigate = () => {
    if (selectedBookings.length > 0) {
      navigate(`/transactions`, { state: { selectedBookings } });
    }
  };

  /*const handlPayed = (Booking) => {
    //const dataBookiong = [Booking]
    navigate(`/transactions`, { state: { selectedBookings: [Booking] } });
  }*/

  const isSelected = (booking) =>
    selectedBookings.some((b) => b.id === booking.id);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {" "}
          <TitreGraphik>
            <span onClick={() => navigate(-1)}>⬅</span>
            {"Bookings List"}
          </TitreGraphik>
        </Grid>
        <Grid item xs={12}>
          <Card sx={{ display: { xs: "none", md: "flex" }, padding: "2%" }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TextField
                    placeholder={t(
                      "Search by booking ID or customer phone number"
                    )}
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  />


                  <Box sx={{
                    display: "flex",
                    flexDirection: "row"
                  }}>
                    <Button
                      variant="contained" sx={{ marginRight: 2 }}
                      color="primary"
                      onClick={() => { setOpenAddCommand(true) }}

                    >
                      Add New Command
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleNavigate}
                      disabled={selectedBookings.length === 0} // Disable if no booking is selected
                    >
                      paye Selected Booking
                    </Button>
                  </Box>






                </Box>
              </Grid>

              <Grid item xs={12}>
                <TableContainer>
                  <Table sx={{ minWidth: 700 }}>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">Select</StyledTableCell>

                        <StyledTableCell align="center">
                          {t("ID")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("customers")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("Price")}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {t("Date")}
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((b) => {
                        return (
                          <StyledTableRow key={b.id}>
                            <StyledTableCell align="center">
                              <Checkbox
                                checked={isSelected(b)}
                                onChange={() => handleSelectBooking(b)}
                              />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              #{b.code}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {b.client}
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              <NumericFormatEnv Number={parseFloat(b.montant_Reste)} />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                              {formatDate(b.created_at)}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <TablePagination
                    component="div"
                    count={totalCount}
                    page={currentPage}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 25, 50]}
                  />
                </TableContainer>
              </Grid>
            </Grid>
          </Card>
          {/* Mobile View */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <Box width="100%">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    placeholder={t(
                      "Search by booking ID or customer phone number"
                    )}
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={handleNavigate}
                    disabled={selectedBookings.length === 0} // Disable if no booking is selected
                  >
                    paye Selected Booking
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={() => { setOpenAddCommand(true) }}

                  >
                    Add New Command
                  </Button>
                </Grid>
                {data.map((b) => {
                  return (
                    <Grid item xs={12} key={b.id}>
                      <Card
                        variant="outlined"
                        sx={{ maxWidth: 345, width: "95%", margin: "auto" }}
                      >
                        <CardContent>
                          <LabelTypography textAlign="center">
                            {t("ID")} : #{b.code}
                          </LabelTypography>
                          <Divider sx={{ margin: "10px 0" }} />

                          <LabelTypography color="text.primary">
                            {t("customers")} : {b.client}
                          </LabelTypography>

                          <Divider sx={{ margin: "10px 0" }} />
                          <LabelTypography color="text.primary">
                            {t("Price")} : <NumericFormatEnv Number={parseFloat(b.montant_Reste)} />
                          </LabelTypography>
                          <LabelTypography color="text.primary">
                            {t("Date")} : {formatDate(b.created_at)}
                          </LabelTypography>

                          <Divider sx={{ margin: "10px 0" }} />
                          <Checkbox
                            checked={isSelected(b)}
                            onChange={() => handleSelectBooking(b)}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
                <Grid item xs={12}>
                  <Box
                    sx={{
                      marginTop: "3%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination
                      count={Math.ceil(totalCount / rowsPerPage)}
                      onChange={(event, newPage) => {
                        setCurrentPage(newPage - 1); // Adjust for 0-based indexing
                      }}
                      variant="outlined"
                      color="primary"
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <AddCommandDialog open={openAddCommand} onClose={() => setOpenAddCommand(false)} onSuccess={() => { setCurrentPage(0); fetchJourneys(0, rowsPerPage) }} />
    </Box>
  );
}
